module.exports = __webpack_public_path__ + "img/ckko3.046b210f.jpeg";